import { parseCSVFile } from './parse-csv';
import { parseExcelFile } from './parse-excel';
import type { ExtendedParseResult, ParseOptions } from './types';

export const parseSupportFile = <T extends Record<string, unknown>>(
    file: File,
    complete: (results: ExtendedParseResult<T>) => void,
    error: (err: Error) => void,
    options: ParseOptions = {},
) => {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();

    if (fileExtension === 'csv') {
        parseCSVFile(file, complete, error, options.config);
    } else if (['xlsx', 'xls'].includes(fileExtension || '')) {
        parseExcelFile(file, complete, error, options);
    } else {
        error(new Error('Unsupported file format. Please upload a CSV or Excel file.'));
    }
};
